import Modal from './Modal';
import classes from './ConfirmationModal.module.css';
import Spinner from '../Spinner/Spinner';
import PrimaryButton from '../Buttons/PrimaryButton';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  body?: string;
  apiStatus: string;
};

const ConfirmationModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  body,
  apiStatus,
}) => {
  const { translations } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={classes.container}>
        <div className={classes.title}>{title}</div>
        {body && <div className={classes.description}>{body}</div>}
        {apiStatus === 'pending' ? (
          <Spinner />
        ) : (
          <PrimaryButton
            onClick={onConfirm}
            text={translations('confirm')}
            disabled={false}
            containerStyle={{}}
          />
        )}
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
